import { ViewportContextProps } from "../contexts/viewportContext";

export const RESPONSIVE_WIDTHS = {
    '4K': 3840,
    '2K': 2560,
    'FHD': 1920,
    'HD': 1280,
}

export const RESPONSIVE_HEIGHTS = {
    '4K': 2160,
    '2K': 1440,
    'FHD': 1080,
    'HD': 720,
}

const is4kDisplay = () => {
    const width = window.screen.width;
    const height = window.screen.height;

    if (width >= RESPONSIVE_WIDTHS["4K"] && height >= RESPONSIVE_HEIGHTS["4K"]) {
        return true;
    }
    return false;
}

const is2kDisplay = () => {
    const width = window.screen.width;
    const height = window.screen.height;

    if (width >= RESPONSIVE_WIDTHS["2K"] && height >= RESPONSIVE_HEIGHTS["2K"]) {
        return true;
    }
    return false;
}

const isFhdDisplay = () => {
    const width = window.screen.width;
    const height = window.screen.height;

    if (width >= RESPONSIVE_WIDTHS.FHD && height >= RESPONSIVE_HEIGHTS.FHD) {
        return true;
    }
    return false;
}

export const viewportContextValues: ViewportContextProps = {
    is4k: is4kDisplay(),
    is2k: is2kDisplay(),
    isFhd: isFhdDisplay(),
    width: window.innerWidth,
    height: window.innerHeight
}


export const convertToPixelFromVW = (value: number) => {
    return convertToPixels(`${value}vw`)
}
export const convertToPixelFromVH = (value: number) => {
    return convertToPixels(`${value}vh`)
}

export const convertToPixels = (value: string, options?: { percentageForHeight?: boolean }) => {

    const vwMatch = value.match(/^(\d*\.?\d+)vw$/);
    const vhMatch = value.match(/^(\d*\.?\d+)vh$/);
    const percentMatch = value.match(/^(\d*\.?\d+)%$/);

    if (vwMatch) {
        const vwValue = parseFloat(vwMatch[1]);
        return (vwValue / 100) * window.innerWidth;
    } else if (vhMatch) {
        const vhValue = parseFloat(vhMatch[1]);
        return (vhValue / 100) * window.innerHeight;
    } else if (percentMatch) {
        const percentValue = parseFloat(percentMatch[1]);
        return !options?.percentageForHeight ? (percentValue / 100) * window.innerWidth : (percentValue / 100) * window.innerHeight;
    } else {
        throw new Error("Invalid value. Use 'xvw', 'xvh', or 'x%' format.");
    }
}